<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.orders_history') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <div v-if="(orders.length === 0)" class="text-center mt-8">
              <div>
                <img src="@/assets/images/v2/img/no_data_order.png" alt="No data" width="300px" class="mb-2">
              </div>
              <div class="font-18 font-weight-700">
                {{ $t('v2.no_orders') }}
              </div>
            </div>
            <div v-else v-scroll="onScrollItem" class="list-order">
              <v-row>
                <v-col v-for="(order, x) in orders" :key="x" cols="12" sm="12" class="py-0">
                  <div class="position-relative item-order" @click="goToDetail(order.id)">
                    <div class="wrap-item-order">
                      <div class="item-avatar-order">
                        <img :src="getImageOrder(order)" alt="Order" @error="imageLoadError">
                        <div v-if="totalItem(order) > 1" class="layer-menu">
                          <img src="@/assets/images/v2/img/icon_layer.png" alt="Total menu">
                          <div class="font-12 font-weight-600 ol-black">
                            {{ totalItem(order) }} menu
                          </div>
                        </div>
                      </div>
                      <div class="item-content-order align-self-start">
                        <div class="item-content-order-text font-12 font-weight-400 ol-grey-content mb-2">
                          {{ formatDate(order.forder_date) }}. {{ order.forder_time }}
                        </div>
                        <div class="item-content-order-text font-14 line-height-normal ol-black mb-2">
                          {{ formatName(order) }}
                        </div>
                        <div class="item-content-order-text font-16 font-weight-600 ol-black mb-2">
                          <span v-mask-money="order.total_amount" />
                        </div>
                        <div :class="['item-status-order', { 'order_pending': order.status_inquiry === 1, 'order_confirm': order.status_inquiry === 2, 'order_ready': order.status_inquiry === 3 || order.status_inquiry === 4 , 'order_done': order.status_inquiry === 5, 'order_failed': order.status_inquiry === 6 || order.status_inquiry === 7 }]">
                          {{ order.status_desc }}
                        </div>
                      </div>
                    </div>
                    <hr class="line-order">
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import {
  getData as getDataOrder
} from '@/api/order'
export default {
  data() {
    return {
      orders: [],
      params: {
        search_column: ['status_inquiry'],
        search_operator: ['in'],
        search_text: ['5,6,7,8'],
        page: 1,
        per_page: 20,
        sort_column: 'order_time',
        sort_type: 'desc'
      },
      settingScroll: {
        order: false
      }
    }
  },
  computed: {
    dataParams() {
      var params = {
        page: this.params.page,
        per_page: this.params.per_page,
        sort_column: 'order_time',
        sort_type: 'desc'
      }
      if (this.params.search_column.length > 0) {
        params.search_column = this.params.search_column
        params.search_operator = this.params.search_operator
        params.search_text = this.params.search_text
      }
      return params
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    totalItem(order) {
      let item_redeem = 0
      for (let i = 0; i < order.items.length; i++) {
        if (order.items[i].note === 'REDEEMED') {
          item_redeem = item_redeem + 1
        }
      }
      return order.items.length - item_redeem
    },
    goBack() {
      this.$router.push({ name: '_orders' }).catch(() => {})
    },
    goToDetail(id) {
      this.$router.push({ name: '_transaction', params: { id: id }}).catch(() => {})
    },
    formatName(order) {
      let name = this.$t('v2.product')
      const arr = []
      if (order.items.length > 0) {
        for (let i = 0; i < order.items.length; i++) {
          if (order.items[i].note !== 'REDEEMED') {
            arr.push(order.items[i].item_name)
          }
        }
        name = arr.join(', ')
      }
      return name
    },
    formatDate(date) {
      const order_date = new Date(date)
      const today = new Date()
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      if (order_date.toDateString() === today.toDateString()) {
        return this.$t('v2.today')
      } else if (order_date.toDateString() === yesterday.toDateString()) {
        return this.$t('v2.yesterday')
      } else {
        return date
      }
    },
    getImageOrder(order) {
      let url_img = require('@/assets/images/v2/img/no_image.png')
      if (order.items.length > 0) {
        if (order.items[0].product_combo_id !== 0) {
          url_img = order.items[0].product_combo_photo_md
        } else {
          for (let i = 0; i < order.items.length; i++) {
            if (order.items[i].note !== 'REDEEMED') {
              url_img = order.items[i].product_photo_md
              break
            } else if (i === (order.items.length - 1) && order.items[i].note === 'REDEEMED') {
              url_img = order.items[0].product_photo_md
              break
            }
          }
        }
      }
      return url_img
    },
    onScrollItem() {
      this.scrollLoadOrder()
    },
    scrollLoadOrder: debounce(async function() {
      if (this.settingScroll.order === false) {
        if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
          this.fetchOrders()
        }
      }
    }, 500),
    async fetchOrders() {
      try {
        const { data } = await getDataOrder(this.dataParams)
        this.settingScroll.order = (data.data.length < this.params.per_page)
        for (var i in data.data) {
          this.orders.push(data.data[i])
        }
        this.params.page++
      } catch (e) {
        this.settingScroll.order = true
        this.orders = []
        if (e.statusCode !== 404) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
